<template>
    <p class="mt-2 text-sm text-red-600" v-if="value">{{ value }}</p>
</template>

<script>
export default {
    name: 'FormError',
    props: {
        value: {
            required: true,
        },
    },
};
</script>
